export default __webpack_public_path__ + "static/backgroundMedia-c06d261a49beb2544157c24f09e59fa5.jpg";